module.exports = __webpack_public_path__ + "img/ueber-mich_1920.6e2e495d.png";